import * as ui from './ui';
import * as auth from './auth';
import * as booking from './booking';
import * as listing from './listing';
import * as query from './query';
import * as idVerification from './id-verification';
import * as payment from './payment';
import * as plus from './plus';
import * as transaction from './transaction';
import * as specialOffer from './special-offer';
import * as reviews from './reviews';
import * as otp from './otp';

const handlers = {
  ...ui,
  ...auth,
  ...booking,
  ...listing,
  ...query,
  ...idVerification,
  ...payment,
  ...plus,
  ...transaction,
  ...specialOffer,
  ...reviews,
  ...otp,
};

export default handlers;
